import type { MessageKey } from './en';

/** Core gameplay strings; anything missing falls back to English. Needs native-speaker review. */
export const gu: Partial<Record<MessageKey, string>> = {
  'app.name': 'મેંડીકોટ',
  'app.tagline': 'દસ્સાની ક્લાસિક ભારતીય રમત',
  'common.cancel': 'રદ કરો',
  'common.close': 'બંધ કરો',
  'common.back': 'પાછા',
  'common.continue': 'આગળ વધો',
  'common.loading': 'લોડ થઈ રહ્યું છે…',

  'home.greeting': 'નમસ્તે, {{name}}',
  'home.playFriends': 'મિત્રો સાથે રમો',
  'home.playFriendsDesc': 'ખાનગી ટેબલ · કોડથી બોલાવો',
  'home.practice': 'બોટ સાથે પ્રેક્ટિસ',
  'home.practiceDesc': 'ઑફલાઇન · તમારી ઝડપે',
  'home.join': 'કોડથી જોડાઓ',
  'home.howTo': 'કેવી રીતે રમવું',

  'create.title': 'ટેબલ ગોઠવો',
  'create.players': 'ખેલાડીઓ',
  'create.trump': 'હુકમ',
  'create.trump.CUT': 'કાપ (કટ)',
  'create.trump.BAND_A_AUTO': 'બંધ હુકમ',
  'create.create': 'ટેબલ બનાવો',
  'create.deal': 'પત્તાં વહેંચો',
  'create.name': 'તમારું નામ',

  'join.title': 'ટેબલમાં જોડાઓ',
  'join.code': 'રૂમ કોડ',
  'join.submit': 'બેઠક લો',

  'lobby.share': 'મિત્રોને બોલાવો',
  'lobby.copy': 'લિંક કૉપિ કરો',
  'lobby.waiting': 'ખેલાડીઓની રાહ…',
  'lobby.ready': 'હું તૈયાર છું',
  'lobby.isReady': 'તૈયાર',
  'lobby.start': 'મૅચ શરૂ કરો',
  'lobby.addBot': 'બોટ ઉમેરો',
  'lobby.emptySeat': 'ખાલી બેઠક',
  'lobby.you': 'તમે',
  'lobby.leave': 'ટેબલ છોડો',

  'table.yourTurn': 'તમારો વારો',
  'table.waitingFor': '{{name}} વિચારે છે…',
  'table.trump': 'હુકમ',
  'table.trumpHidden': 'છુપાયેલ',
  'table.trumpNone': 'નક્કી નથી',
  'table.tens': 'દસ્સા',
  'table.tricks': 'હાથ',
  'table.you': 'તમે',
  'table.partner': 'સાથી',

  'result.win': 'તમારી ટીમે બાજી જીતી!',
  'result.loss': 'આ બાજી બીજી ટીમની',
  'result.coat': 'મેંડીકોટ!',
  'result.whitewash': 'વાઇટવૉશ!',
  'result.next': 'આગલી બાજી',
  'result.seeMatch': 'મેચનું પરિણામ જુઓ',

  'match.won': 'મૅચ જીત્યા!',
  'match.lost': 'મૅચ હાર્યા',
  'match.rematch': 'ફરી રમો',

  'suit.S': 'કાળી',
  'suit.H': 'લાલ',
  'suit.D': 'ચોકટ',
  'suit.C': 'ફુલ્લી',
  'team.us': 'અમે',
  'team.them': 'તેઓ',

  'theme.diwali': 'દિવાળી',
  'theme.navratri': 'નવરાત્રિ',
  'greeting.diwali': 'શુભ દીપાવલી! ટેબલ ઝગમગાવો.',
  'greeting.navratri': 'શુભ નવરાત્રિ!',

  'settings.analytics': 'ઉપયોગ ડેટા શેર કરો',
  'settings.privacy': 'ગોપનીયતા અને ડેટા',
  'settings.downloadData': 'મારો ડેટા ડાઉનલોડ કરો',
  'settings.downloadDone': 'તમારી ડેટા ફાઇલ ડાઉનલોડ થઈ રહી છે',
  'settings.privacyPolicy': 'ગોપનીયતા નીતિ',
  'gate.title': 'રમતા પહેલાં',
  'gate.age': 'મેંડીકોટ 18 વર્ષ અને તેથી વધુ ઉંમરના ખેલાડીઓ માટે છે.',
  'gate.noticeIntro': 'અમે શું વાપરીએ છીએ, અને શા માટે:',
  'gate.item.game':
    'એક ગેસ્ટ આઈડી, તમારું ઉપનામ, અવતાર અને તમારી રમતો — તમારાં ટેબલ ચલાવવા અને તમારા આંકડા રાખવા માટે.',
  'gate.item.account':
    'તમારો ઈમેલ અથવા Google નામ — ફક્ત ત્યારે જ જ્યારે તમે તમારી પ્રગતિ સાચવવા સાઇન ઇન કરો.',
  'gate.item.push': 'એક નોટિફિકેશન ટોકન — ફક્ત ત્યારે જ જ્યારે તમે રિમાઇન્ડર ચાલુ કરો.',
  'gate.item.security': 'Google reCAPTCHA દ્વારા સુરક્ષા તપાસ — બૉટ્સને દૂર રાખવા માટે.',
  'gate.item.analytics':
    'ઉપયોગ, પર્ફોર્મન્સ અને ક્રેશ ડેટા, એક રેન્ડમ આઈડી સાથે જોડાયેલો, તમારું નામ કે ઈમેલ ક્યારેય નહીં — ફક્ત તમારી મંજૂરીથી.',
  'gate.rights':
    'સેટિંગ્સમાં ગમે ત્યારે તમારો ડેટા ડાઉનલોડ કરો કે કાઢી નાખો, અને તમારી પસંદગી બદલો.',
  'gate.policy': 'ગોપનીયતા નીતિ',
  'gate.playShare': 'હું 18+ છું · ઉપયોગ ડેટાની મંજૂરી આપો',
  'gate.playNoShare': 'હું 18+ છું · શેર ન કરો',
  'gate.under18': 'મારી ઉંમર 18 કરતાં ઓછી છે',
  'gate.blockedTitle': 'માફ કરશો, તમારી ઉંમર 18 હોવી જોઈએ',
  'gate.blockedBody': 'મેંડીકોટ ફક્ત 18 વર્ષ અને તેથી વધુ ઉંમરના ખેલાડીઓ માટે છે.',
  'gate.blockedBack': 'મારી ભૂલ થઈ',
  'privacy.title': 'ગોપનીયતા નીતિ',
  'privacy.languageNote':
    'આ નીતિ અંગ્રેજીમાં છે. ગુજરાતી, હિન્દી, મરાઠી અથવા અન્ય ભારતીય ભાષામાં નકલ માટે અમને ઈમેલ કરો.',
};
